import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'Components';
import i18n from 'i18next';
import AppContext from 'src/AppContext';
import { useSelector } from 'react-redux';
import NavMobileFilter from '../NavMobileFilter/NavMobileFilter';
import NavMobileItemList from '../NavMobileItemList/NavMobileItemList';
import './NavMobileMainMenu.css';

const NavMobileMainMenu = ({
  setAppState,
  isInternalUser,
  filterFields,
  filterFieldValue,
  filterItemValue,
  filterItems,
  filterPinnedItems,
  togglePin,
  clientNumber,
  clients,
  setNavState,
  viewMore,
}) => {
  const ProjectTitle = filterFields.options.find(opt => opt.value === filterFieldValue) || { label: '' };
  const { REGION_CONTACT_EMAIL } = useSelector(state => state.appConfig);

  return (
    <div className="nav-mobile-main-menu">
      {
        isInternalUser &&
        <div className="nav-mobile-main-menu__clients">
          <NavMobileFilter
            title="Clients"
            isVirtual
            onChange={option => setAppState(prevState => ({
              userInfo: {
                ...prevState.userInfo,
                ClientNumber: option.value,
              },
            }))}
            options={clients.options}
            value={clientNumber}
            setNavState={setNavState}
          />
          <hr className="nav-mobile-main-menu__seperator" />
        </div>
      }

      <div className="nav-mobile-main-menu__items">
        { filterItems.isLoading && <Loader /> }
        <NavMobileFilter
          title={ProjectTitle.label}
          filterItemValue={filterItemValue}
          filterFields={filterFields}
          showAllProjects
          onChange={option => setAppState({ filterFieldValue: option.value, filterFields: '' })}
          options={filterFields.options}
          value={filterFieldValue}
          setNavState={setNavState}
        />

        { filterPinnedItems.options.length > 0 &&
          <NavMobileItemList
            title="Pinned"
            togglePin={togglePin}
            filterItemValue={filterItemValue}
            setNavState={setNavState}
            isLoading={filterItems.isLoading}
            options={filterPinnedItems.options}
            isPinned
          />
        }

        <NavMobileItemList
          viewMore={viewMore}
          onViewMore={() => setNavState(state => ({ ViewMore: !state.ViewMore }))}
          showViewAll
          setNavState={setNavState}
          togglePin={togglePin}
          filterItemValue={filterItemValue}
          isLoading={filterItems.isLoading}
          options={filterItems.options.filter(x => !x.isPinned)}
        />
      </div>
      <div className="nav-mobile-main-menu__footer">
        <a className="nav_mobile-main-menu__footer__contact" href={`mailto:${REGION_CONTACT_EMAIL}`}>
          {i18n.t('nav:Contact Us')}
        </a>
      </div>
    </div>
  );
};

const propTypeOptions = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string,
});

NavMobileMainMenu.propTypes = {
  viewMore: PropTypes.bool,
  setNavState: PropTypes.func,
  setAppState: PropTypes.func,
  isInternalUser: PropTypes.bool,
  togglePin: PropTypes.func,
  userInfo: PropTypes.shape({}),
  clients: PropTypes.shape({
    options: PropTypes.arrayOf(propTypeOptions),
  }),
  filterPinnedItems: PropTypes.shape({}),
  clientNumber: PropTypes.string,
  filterItemValue: PropTypes.string,
  filterItems: PropTypes.shape({
    options: PropTypes.arrayOf(propTypeOptions),
  }),
  filterFieldValue: PropTypes.string,
  filterFields: PropTypes.shape({
    isLoading: PropTypes.bool,
    options: PropTypes.arrayOf(propTypeOptions),
  }),
};

export default props => (
  <AppContext.Consumer>
    {context => (
      <NavMobileMainMenu
        {...props}
        setAppState={context.setAppState}
        isInternalUser={context.isInternalUser}
      />
    )}
  </AppContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/containers/Nav/NavMobile/NavMobileMainMenu/NavMobileMainMenu.jsx